import PropTypes from 'prop-types';
import React from 'react';

import Footer from '../layouts/footer/Footer';
import Header from '../layouts/header/Header';
import Menu from '../layouts/menu/Menu';

import Api from '../../utils/api';


export default class Base extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      facebookPageId: '',
      theme: '',
      profile: {},
      properties: {},
    };
  }

  componentDidMount() {
    Api.properties(this.props.params.partnerSlug)
      .then((properties) => {
        this.setState({
          theme: properties.theme,
          properties,
        });

        if (!properties.code) {
          return;
        }

        Api.profile(properties.code)
          .then((profile) => {
            this.setState({
              facebookPageId: profile.facebook_page_id,
              profile,
            });
          })
          .fail((error) => {
            console.error(error);
            this.setState({ profile: {} });
          });
      })
      .fail(() => this.setState({ properties: {} }));
  }

  render() {
    const renderer = (<div>
      <style type="text/css">{this.state.theme}</style>

      <Header
        profile={this.state.profile}
        partnerSlug={this.props.params.partnerSlug}
      />

      <Menu
        facebookPageId={this.state.facebookPageId}
        partnerSlug={this.props.params.partnerSlug}
      />

      {React.cloneElement(this.props.children, {
        profile: this.state.profile,
        properties: this.state.properties,
      })}

      <Footer />
    </div>);

    if (Object.keys(this.state.profile).length) { return renderer; }
    return (
      <div className="base-loader">
        <div className="lds-dual-ring" />
      </div>);
  }
}

Base.propTypes = {
  children: PropTypes.node,
  params: PropTypes.shape({
    partnerSlug: PropTypes.string,
  }),
};

module.exports = Base;



// WEBPACK FOOTER //
// ./app/pages/Base.jsx